import React, { useCallback } from "react";
import { Field, Filter, RangePicker, Text, TimePicker } from "components/commons";
import lang from "translations";

const MdmFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  applyFilter,
}) => {

  const changeDateRangeCb = useCallback(
    (name, value) => {
      modifyFilter(name, { value });
    },
    [modifyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  return (
    <Filter
      placeholder={lang.searchMdmDevices}
      className="my-lg"
      filterState={filterState}
      onApply={applyFilter}
      onClear={clearFilterCb}
      actionsSpan={4}
      
    >
      <Field filterLabel={lang.date} className="col-span-4">
        <RangePicker name="dateRange" value={filterState.dateRange} onChange={changeDateRangeCb} />
      </Field>
      <Field filterLabel={lang.timeRange} className="col-span-4">
        <div className="flex items-center">
          <TimePicker
            value={filterState.dateRange[0]}
            onChange={(startTime) => {
              modifyFilter("dateRange", {
                value: [
                  filterState.dateRange[0].set({
                    hour: startTime.get("hour"),
                    minute: startTime.get("minute"),
                  }),
                  filterState.dateRange[1],
                ],
              });
            }}
          />
          <Text className="mx-sm" color="text-black-light">
            {lang.to}
          </Text>
          <TimePicker
            value={filterState.dateRange[1]}
            onChange={(endTime) => {
              modifyFilter("dateRange", {
                value: [
                  filterState.dateRange[0],
                  filterState.dateRange[1].set({
                    hour: endTime.get("hour"),
                    minute: endTime.get("minute"),
                  }),
                ],
              });
            }}
          />
        </div>
      </Field>
    </Filter>
  );
};

export default MdmFilter;
